import React from 'react';
import Table from '../../../Components/Home/Table/Table';

const AllSchedule = () => {
    return (
        <div className='mt-20'>
            <Table/>
        </div>
    );
};

export default AllSchedule;